import {
  jsx as _jsx,
  Fragment as _Fragment,
  jsxs as _jsxs,
} from 'react/jsx-runtime';
import { createPortal } from 'react-dom';
import * as Styled from './Modal.styles.js';
const Modal = ({
  children,
  isModalOpen = false,
  closeModal,
  position = 'center',
  width = '220px',
  height = '220px',
}) => {
  return createPortal(
    _jsx(_Fragment, {
      children:
        isModalOpen &&
        _jsxs(_Fragment, {
          children: [
            _jsx(Styled.ModalBackdrop, {
              onClick: () => {
                closeModal();
              },
            }),
            _jsx(
              Styled.Modal,
              Object.assign(
                { width: width, height: height, modalPosition: position },
                { children: children }
              )
            ),
          ],
        }),
    }),
    document.body
  );
};
export default Modal;
